/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractDeadlineDtoState = typeof ContractDeadlineDtoState[keyof typeof ContractDeadlineDtoState];


export const ContractDeadlineDtoState = {
  upcoming: 'upcoming',
  due: 'due',
  passed: 'passed',
  reached: 'reached',
} as const;
